export default function initTransformToAccordion() {
    const $transformToAccordion = document.querySelectorAll<HTMLElement>('.js-transform-to-accordion');
    $transformToAccordion.forEach($el => {
        new TransformToAccordion($el);
    });
}

export class TransformToAccordion {
    $el: HTMLElement | null | undefined;
    firstDetails: boolean = true;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.init();
    }

    init() {
        if (!this.$el) return;

        const paragraphs = this.$el.querySelectorAll('p');
        let currentDetails: HTMLDetailsElement | null = null;

        paragraphs.forEach((p) => {
            const strong = p.querySelector('strong');
            
            if (strong) {
                // Si on trouve un nouveau strong, on crée un nouveau details
                currentDetails = document.createElement('details');
                
                // Ouvrir le premier details par défaut
                if (this.firstDetails) {
                    currentDetails.open = true;
                    this.firstDetails = false;
                }
                
                const summary = document.createElement('summary');
                summary.innerHTML = strong.innerHTML;
                currentDetails.appendChild(summary);

                // On déplace tout le contenu après le strong dans le details
                let nextNode = strong.nextSibling;
                while (nextNode) {
                    const tempNode = nextNode.nextSibling;
                    currentDetails.appendChild(nextNode);
                    nextNode = tempNode;
                }

                // On remplace le paragraphe original par le details
                p.parentNode?.replaceChild(currentDetails, p);

                // On cherche les éléments suivants jusqu'au prochain paragraphe avec strong
                let nextElement = currentDetails.nextElementSibling;
                while (nextElement && !(nextElement.tagName === 'P' && nextElement.querySelector('strong'))) {
                    const tempElement = nextElement.nextElementSibling;
                    currentDetails.appendChild(nextElement);
                    nextElement = tempElement;
                }
            } else if (currentDetails) {
                // Si pas de strong mais qu'on a un details en cours, on ajoute le contenu
                currentDetails.appendChild(p.cloneNode(true));
                p.remove();
            }
        });

        // Ajouter le comportement d'accordéon après la création de tous les details
        this.initAccordionBehavior();
    }

    initAccordionBehavior() {
        if (!this.$el) return;

        const $allDetails = this.$el.querySelectorAll<HTMLDetailsElement>('details');
        
        $allDetails.forEach($details => {
            $details.addEventListener('toggle', () => {
                if ($details.open) {
                    // Fermer tous les autres details de cet élément
                    $allDetails.forEach($otherDetails => {
                        if ($otherDetails !== $details && $otherDetails.open) {
                            $otherDetails.open = false;
                        }
                    });
                }
            });
        });
    }
}